<template>

  <div class="stepper">
    <div class="md-stepper-horizontal">

      <div class="md-step" :class="{'active': index === currentState}" v-for="(state, index) in states" :key="state.number">
        <div class="md-step-circle" ><span>{{state.number}}</span></div>
        <div class="md-step-title">  {{state.title}}</div>
        <div class="md-step-bar-left"></div>
        <div class="md-step-bar-right"></div>
      </div>
    </div>

  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
export default {
  name: 'stepper',
  props: [ 'states', 'currentState' ],
  computed: {
    stateNames() {
      const names = [];
      Object.keys(this.states).forEach(state => {
        names.push({
          name: state,
          title: this.states[state].title
        });
      });
      return names;
    }
  },
  data() {
    return {
    };
  },
  methods: {

  },
  components: { FontAwesomeIcon }
};
</script>

<style lang="scss">
@import './../../scss/variables';
.stepper {
  .md-stepper-horizontal {
    display:table;
    width:100%;
    margin:0 auto;
  }

  .md-stepper-horizontal .md-step {
    display:table-cell;
    position:relative;
    padding:24px;
    width: 1em;
  }
  .md-stepper-horizontal
  .md-stepper-horizontal .md-step:active {
    background-color:rgba(0,0,0,0.04);
  }
  .md-stepper-horizontal .md-step:active {
    border-radius: 15% / 75%;
  }
  .md-stepper-horizontal .md-step:first-child:active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .md-stepper-horizontal .md-step:last-child:active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .md-stepper-horizontal .md-step:first-child .md-step-bar-left,
  .md-stepper-horizontal .md-step:last-child .md-step-bar-right {
    display:none;
  }
  .md-stepper-horizontal .md-step .md-step-circle {
    width:30px;
    height:30px;
    margin:0 auto;
    // background-color:#999999;
    border-radius: 50%;
    text-align: center;
    line-height:30px;
    font-size: 16px;
    // font-weight: 600;
    color:#FFFFFF;
  }

  .md-stepper-horizontal .md-step.done .md-step-circle *,
  .md-stepper-horizontal .md-step.editable .md-step-circle * {
    display:none;
  }
  .md-stepper-horizontal .md-step.editable .md-step-circle {
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .md-stepper-horizontal .md-step .md-step-title {
    margin-top:16px;
    font-size: $small-font-size;
    // font-weight:600;
  }
  .md-stepper-horizontal .md-step .md-step-title,
  .md-stepper-horizontal .md-step .md-step-optional {
    text-align: center;
    color:rgba(0,0,0,.26);
  }
  .md-stepper-horizontal .md-step.active .md-step-title {
    // font-weight: 600;
    color:rgba(0,0,0,.87);
  }
  .md-stepper-horizontal .md-step.active.done .md-step-title,
  .md-stepper-horizontal .md-step.active.editable .md-step-title {
    // font-weight:600;
  }
  .md-stepper-horizontal .md-step .md-step-optional {
    font-size:12px;
  }
  .md-stepper-horizontal .md-step.active .md-step-optional {
    color:rgba(0,0,0,.54);
  }
  .md-stepper-horizontal .md-step .md-step-bar-left,
  .md-stepper-horizontal .md-step .md-step-bar-right {
    position:absolute;
    top:36px;
    height:1px;
    // border-top:1px solid #DDDDDD;
  }
  .md-stepper-horizontal .md-step .md-step-bar-right {
    right:0;
    left:50%;
    margin-left:20px;
  }
  .md-stepper-horizontal .md-step .md-step-bar-left {
    left:0;
    right:50%;
    margin-right:20px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/misc/stepper.vue